import { Stack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import BaseDropdownV2 from '../../../../shared/components/dropdown/base-dropdown-v2/base-dropdown-v2.component';
import BaseInput from '../../../../shared/components/input/base-input/base-input.component';

export const FullWidthDropdown = styled(BaseDropdownV2)(() => ({
  width: '100%',
}));

export const SourceLinkInput = styled(BaseInput)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-root .MuiInputBase-input': {
    paddingLeft: '0.75rem',
    border: `1px solid ${theme.palette.neutrals.gray.low}`,
  },
}));

export const FileUploadContainer = styled(Stack)<StackProps>(() => ({
  width: '100%',
}));

export const FormRow = styled(Stack)<StackProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  marginBottom: '20px',
}));

export const DialogContent = styled(Stack)(() => ({
  padding: '20px',
}));

export const ButtonContainer = styled(Stack)(() => ({
  marginTop: '20px',
  justifyContent: 'flex-end',
}));
